import { useMemo, useState } from "react";
import Tippy from "@tippyjs/react";

import * as types from "types";
import useDownloadFile from "services/cortevaChain/hooks/useDownloadFile";
import Loading from "./Loading";
import Error from "./Error";
import DisabledTooltip from "./DisabledTooltip";
import "./ImagePreview.css";

interface ImagePreviewProps {
  fileName: string;
  chatThread: types.ChatThread;
  permalink?: string | null;
}

export default function ImagePreview({
  fileName,
  chatThread,
  permalink,
}: ImagePreviewProps) {
  const { data, error } = useDownloadFile({ chatThread, fileName, permalink });
  const url = useMemo(() => data && URL.createObjectURL(data), [data]);
  const [isLoading, setIsLoading] = useState(true);

  const currentPersona = types.getPersonaById(chatThread.personaId);

  const isGrayedOut = currentPersona?.imageCapable === false;

  if (error) {
    return <Error />;
  }

  return (
    <>
      {isLoading && <Loading />}
      {url && (
        <Tippy
          disabled={!isGrayedOut}
          content={
            currentPersona && (
              <DisabledTooltip currentPersona={currentPersona} />
            )
          }
        >
          <div className="image-container">
            <img
              className={`image-preview ${isGrayedOut ? "image-disabled" : ""}`}
              alt={fileName}
              src={url}
              onLoad={() => setIsLoading(false)}
            />
          </div>
        </Tippy>
      )}
    </>
  );
}
